export default {};
throw new Error(`Could not resolve "ogl" imported by "@appletosolutions/reactbits". Is it installed?`)